import React, { forwardRef, useContext, useEffect, useLayoutEffect, useMemo } from 'react';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import { uniqueId } from 'lodash';
import CbgContext from '../CbgContext';
import useMemoObject from '@dyl/hooks/useMemoObject';

/**
 * @typedef Props
 * @property {import('@mui/material/styles/createBreakpoints').Breakpoint} down
 */

export default forwardRef(
    /**
     * @param {Props & import('@mui/material').ButtonProps} props
     */
    function CollapsibleButton({ down, ...props }, ref) {
        props = useMemoObject(props);

        const id = useMemo(() => uniqueId('cbgb_'), []);

        const { update, unregister } = useContext(CbgContext);

        useLayoutEffect(() => {
            update({ id, down, props });
        }, [down, props]);

        useEffect(() => {
            return () => unregister(id);
        }, []);

        const { breakpoints } = useTheme();
        const hide = useMediaQuery(breakpoints.down(down));

        return !hide && (
            <Button ref={ref} {...props} />
        );
    }
);